import Swal from "sweetalert2";
import "../pages/game/gameStagePopup.css";

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function resolveButtonColor(themeData, fallback = "#2f9e4f") {
  const raw =
    themeData?.button_color ||
    themeData?.colors?.ui_color_1 ||
    themeData?.colors?.ui_color_2;
  if (raw == null || String(raw).trim() === "") return fallback;
  return String(raw).trim();
}

function resolveIconMarkup(icon) {
  if (icon === "success") {
    return `<div class="game-stage-popup__icon game-stage-popup__icon--success" aria-hidden="true">✓</div>`;
  }
  if (icon === "info") {
    return `<div class="game-stage-popup__icon game-stage-popup__icon--info" aria-hidden="true">i</div>`;
  }
  if (icon === "error") {
    return `<div class="game-stage-popup__icon game-stage-popup__icon--error" aria-hidden="true">✕</div>`;
  }
  if (icon) {
    return `<div class="game-stage-popup__icon" aria-hidden="true">${escapeHtml(icon)}</div>`;
  }
  return "";
}

/**
 * Themed in-game alert matching celebration / help modal styling.
 */
export function fireGameStagePopup({
  title,
  html = "",
  icon = "success",
  variant,
  confirmButtonText = "Continue",
  confirmButtonColor,
  themeData,
} = {}) {
  const popupVariant =
    variant ||
    (icon === "error" ? "error" : icon === "info" ? "info" : "success");
  const defaultBtnColor =
    popupVariant === "error"
      ? "#dc2626"
      : resolveButtonColor(themeData);
  const btnColor = confirmButtonColor || defaultBtnColor;

  return Swal.fire({
    html: `<div class="game-stage-popup">
      ${resolveIconMarkup(icon)}
      <h2 class="game-stage-popup__title">${escapeHtml(title)}</h2>
      <div class="game-stage-popup__body">${html}</div>
      <button type="button" class="game-stage-popup__btn" data-game-stage-popup-close>${escapeHtml(confirmButtonText)}</button>
    </div>`,
    showConfirmButton: false,
    showCloseButton: false,
    allowOutsideClick: false,
    allowEscapeKey: true,
    width: "min(92vw, 26em)",
    heightAuto: true,
    scrollbarPadding: false,
    returnFocus: false,
    customClass: {
      popup: `game-stage-popup-shell game-stage-popup-shell--${popupVariant}`,
      htmlContainer: "game-stage-popup-shell__html",
    },
    showClass: { popup: "game-stage-popup-shell--in" },
    didOpen: () => {
      const btn = Swal.getPopup()?.querySelector("[data-game-stage-popup-close]");
      if (btn) {
        btn.style.background = `linear-gradient(135deg, ${btnColor}, ${btnColor})`;
        btn.addEventListener("click", () => Swal.close(), { once: true });
      }
    },
  });
}
